import { jsx as _jsx } from "react/jsx-runtime";
import { skipToken } from '@reduxjs/toolkit/query';
import { useContext } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router';
import { useLoadCentralInstancesQuery, useLoadLicenseOrgsQuery, } from '../../apiClients/entitlementsClient/requests/EntitlementsAPI';
import { useLazyRefreshAccessTokenQuery } from '../../apiClients/identityClient/requests/AccessTokenApi';
import { LOGIN_ERROR_ROUTE, LOGIN_ROUTE, LOGOUT_SUCCESS_ROUTE } from '../../constants';
import { clearCombinedToken as clearAccessToken, getCombinedToken as getAccessToken, } from '../../store/sessionStorageHelpers/accessTokenHelper/accessTokenHelper';
import { clearCSRFState } from '../../store/sessionStorageHelpers/authStateHelpers';
import { setDeeplink } from '../../store/sessionStorageHelpers/deeplinkHelper/deeplinkHelper';
import { clearEntitlements } from '../../store/sessionStorageHelpers/entitlementsHelper/entitlementsHelper';
import { clearPkceVerifier } from '../../store/sessionStorageHelpers/pkceFlowHelpers';
import { LoginContext } from '../loginHandler/LoginContext';
function accessTokenInvalid(error) {
    if (error) {
        const { status } = error;
        if (status && typeof status === 'number' && status >= 400) {
            return true;
        }
    }
    return false;
}
function accessTokenUnauthorized(error) {
    if (error) {
        const { status } = error;
        if (status && typeof status === 'number' && status === 401) {
            return true;
        }
    }
    return false;
}
function clearSession() {
    clearAccessToken();
    clearCSRFState();
    clearEntitlements();
    clearPkceVerifier();
}
export function AccessTokenGuard({ children }) {
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const { forceOauthPrefix, includeClientSecret, service } = useContext(LoginContext);
    const [refreshToken, refreshTokenResult] = useLazyRefreshAccessTokenQuery();
    const authCode = searchParams.get('code');
    const errorCode = searchParams.get('error');
    const accessToken = getAccessToken();
    if (accessToken) {
        const { error } = service === 'central'
            ? useLoadCentralInstancesQuery()
            : useLoadLicenseOrgsQuery(service !== 'none' ? { service } : skipToken);
        if (accessTokenUnauthorized(error) && accessToken.refresh_token) {
            refreshToken({
                forceOauthPrefix,
                includeClientSecret,
                refreshToken: accessToken.refresh_token,
            });
        }
        else if (accessTokenInvalid(error)) {
            clearSession();
            return _jsx(Navigate, { to: LOGIN_ROUTE });
        }
    }
    const expired = accessToken && accessToken.expires_at <= Date.now();
    const noAccessToken = !(accessToken === null || accessToken === void 0 ? void 0 : accessToken.access_token) && !authCode;
    const notLoginRoute = location.pathname !== LOGIN_ROUTE &&
        location.pathname !== LOGIN_ERROR_ROUTE &&
        location.pathname !== LOGOUT_SUCCESS_ROUTE;
    if ((expired || noAccessToken || (refreshTokenResult === null || refreshTokenResult === void 0 ? void 0 : refreshTokenResult.isError)) && notLoginRoute) {
        clearSession();
        const regex = 'login';
        if (errorCode) {
            searchParams.delete('error');
            searchParams.delete('error_description');
            const searchString = searchParams.toString();
            const deepLink = `${location.pathname}${searchString.length > 0 ? `?${searchString}` : ''}`;
            if (!regex.match(location.pathname)) {
                setDeeplink(deepLink);
            }
        }
        else if (!regex.match(location.pathname)) {
            setDeeplink(`${location.pathname}${location.search}`);
        }
        return _jsx(Navigate, { to: LOGIN_ROUTE, state: { from: location }, replace: true });
    }
    return children;
}
//# sourceMappingURL=AccessTokenGuard.js.map